import styled from "styled-components";

const InfoBox = styled.div`
  text-align: left;
  padding: 1em;
  border: 1px solid #6bb0e4;
  border-radius: 5px;
  background: #c7e9ff;
  margin-bottom: 1em;

  p:last-child,
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
  }
`;

export const SuccessBox = styled(InfoBox)`
  background-color: #dff0e1;
  border-color: #83cb8b;
`;

export default InfoBox;
